module.exports = __webpack_public_path__ + "static/img/underReview.d9ec97b2.png";